import { IconProps } from "./types";

export function IconEdit({ size = 20 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <path
        fill={"none"}
        stroke={"currentColor"}
        d="m13 7 4-4 4 4-4 4m-4-4L3 17v4h4l10-10m-4-4 4 4"
        strokeWidth={2}
        strokeLinejoin="round"
      />
    </svg>
  );
}
